const overrideCreateElementReference = (editor, options) => {
  const {
    createElementReferences
  } = options;
  editor.createElementReference = (targetPath, referenceDiscriminant, initialize) => {
    return createElementReferences(editor, targetPath, referenceDiscriminant, initialize);
  };
};
export {
  overrideCreateElementReference
};
//# sourceMappingURL=overrideCreateElementReference.js.map
